import { styled } from 'styled-components'

const ModalTextLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
`

export default ModalTextLabel
